import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"x-radio-group\" role=\"radiogroup\" ...attributes>\n  <XFormGroup @value={{@value}}>\n    {{yield (hash update=@update value=@value)}}\n  </XFormGroup>\n</div>", {
  moduleName: "@qonto/ui-kit/components/x-radio-group.hbs"
});